import React from 'react'
import { MuiGrid} from '../../../ui/MaterialUIComponents';
import IndividualTimeTableGrid from './IndividualTimeTableGrid';
import CalendarGrid from './CalendarGrid'
export default function IndividualTimeTableForClass(props) {
    let header = props.header
    let timeTable = props.timeTable;
    return (
        <MuiGrid container>
            {timeTable.map((class1, index2) => (
                <CalendarGrid {...props} title={class1.name} 
                    noOfTTShowIndex={props.noOfTimeTableToShowIndex}
                index={index2}>
                    <IndividualTimeTableGrid
                     {...props} header={header} classItem={class1} cardIndex={index2}
                        noOfTTShowIndex={props.noOfTimeTableToShowIndex}
                     />
                </CalendarGrid>
            ))}
        </MuiGrid>
    )
}